import { Select, type ComboboxItem, type SelectProps } from '@mantine/core';
import { useEditorContext } from '../EditorContext';
import { setEditorFieldValue, type LooseKeys } from '../types';
import { ModalEditorItemBase } from './ModalEditorItemBase';

export interface ModalSelectItemProps<TFormType> extends Omit<SelectProps, 'value' | 'onChange'> {
    fieldKey: LooseKeys<TFormType>;
    data: ComboboxItem[];
    required?: boolean;
    label?: string;
    labelWidth?: number;
}

export const ModalSelectItem = <TFormType,>({
    fieldKey,
    data,
    required,
    label,
    labelWidth,
    ...selectProps
}: ModalSelectItemProps<TFormType>) => {
    const { form, loading, onSave } = useEditorContext<TFormType>();

    const fieldKeyString = fieldKey as string;
    const error = form.errors[fieldKeyString];

    const handleChange = (value: string | null) => {
        setEditorFieldValue(form, fieldKeyString, value);
    };

    const value = form.getInputProps(fieldKeyString).value;

    return (
        <ModalEditorItemBase
            label={label}
            labelWidth={labelWidth}
            error={error}
            required={required}
            submitChanges={onSave}
        >
            <Select
                key={form.key(fieldKeyString)}
                {...form.getInputProps(fieldKeyString)}
                data={data}
                value={value}
                onChange={handleChange}
                disabled={loading}
                error={false}
                {...selectProps}
            />
        </ModalEditorItemBase>
    );
};
